import React, { useState } from "react";
import "./navbar2.scss";

const Navbar2 = () => {
  const [active, setActive] = useState("home");

  const closeMenu = () => {
    const menu__icon = document.querySelector(".m_icon");
    menu__icon.classList.remove("fa-times");
    menu__icon.classList.add("fa-bars");

    const menu = document.querySelector(".mobileMenu__content");
    menu.classList.remove("activeMobileMenu");
  };

  return (
    <div className="navbar">
      <div className="navbar__container">
        <div className="navbarLogo">
          <span>Ecom Plus BD</span>
        </div>

        <div className="navbar__menu">
          <a
            href="#home"
            onClick={() => setActive("home")}
            className={
              active === "home"
                ? "navbar__menuItem activeNavbar"
                : "navbar__menuItem"
            }
          >
            <span className="navbar__menuItemText">Home</span>
          </a>

          <a
            href="#about"
            onClick={() => setActive("about")}
            className={
              active === "about"
                ? "navbar__menuItem activeNavbar"
                : "navbar__menuItem"
            }
          >
            <span className="navbar__menuItemText">About</span>
          </a>

          <a
            href="#skills"
            onClick={() => setActive("skills")}
            className={
              active === "skills"
                ? "navbar__menuItem activeNavbar"
                : "navbar__menuItem"
            }
          >
            <span className="navbar__menuItemText">Our Services</span>
          </a>

          {/* <a
            href="#projects"
            onClick={() => setActive("projects")}
            className={
              active === "projects"
                ? "navbar__menuItem activeNavbar"
                : "navbar__menuItem"
            }
          >
            <span className="navbar__menuItemText">Projects</span>
          </a> */}

          <a
            href="#contact"
            onClick={() => setActive("contact")}
            className={
              active === "contact"
                ? "navbar__menuItem activeNavbar"
                : "navbar__menuItem"
            }
          >
            <span className="navbar__menuItemText">Contact</span>
          </a>
        </div>

        <div className="mobileMenu">
          <div
            className="mobileMenu__icon"
            onClick={() => {
              const menu__icon = document.querySelector(".m_icon");
              if (menu__icon.classList.contains("fa-bars")) {
                menu__icon.classList.remove("fa-bars");
                menu__icon.classList.add("fa-times");

                const menu = document.querySelector(".mobileMenu__content");
                menu.classList.add("activeMobileMenu");
              } else {
                menu__icon.classList.remove("fa-times");
                menu__icon.classList.add("fa-bars");

                const menu = document.querySelector(".mobileMenu__content");
                menu.classList.remove("activeMobileMenu");
              }
            }}
          >
            <i className="m_icon fas fa-bars"></i>
          </div>

          <div className="mobileMenu__content">
            <a
              href="#home"
              onClick={() =>
                document
                  .querySelector(".mobileMenu__content")
                  .classList.remove("activeMobileMenu") ||
                setActive("home") ||
                closeMenu()
              }
              className={
                active === "home"
                  ? "mobileMenu__contentItem activeNavbarmobile"
                  : "mobileMenu__contentItem"
              }
            >
              <span className="mobileMenu__contentItemText">Home</span>
            </a>

            <a
              href="#about"
              onClick={() =>
                document
                  .querySelector(".mobileMenu__content")
                  .classList.remove("activeMobileMenu") ||
                setActive("about") ||
                closeMenu()
              }
              className={
                active === "about"
                  ? "mobileMenu__contentItem activeNavbarmobile"
                  : "mobileMenu__contentItem"
              }
            >
              <span className="mobileMenu__contentItemText">About</span>
            </a>

            <a
              href="#skills"
              onClick={() =>
                document
                  .querySelector(".mobileMenu__content")
                  .classList.remove("activeMobileMenu") ||
                setActive("skills") ||
                closeMenu()
              }
              className={
                active === "skills"
                  ? "mobileMenu__contentItem activeNavbarmobile"
                  : "mobileMenu__contentItem"
              }
            >
              <span className="mobileMenu__contentItemText">Our Services</span>
            </a>

            {/* <a
              href="#projects"
              onClick={() =>
                document
                  .querySelector(".mobileMenu__content")
                  .classList.remove("activeMobileMenu") ||
                setActive("projects") ||
                closeMenu()
              }
              className={
                active === "projects"
                  ? "mobileMenu__contentItem activeNavbarmobile"
                  : "mobileMenu__contentItem"
              }
            >
              <span className="mobileMenu__contentItemText">Projects</span>
            </a> */}

            <a
              href="#contact"
              onClick={() =>
                document
                  .querySelector(".mobileMenu__content")
                  .classList.remove("activeMobileMenu") ||
                setActive("contact") ||
                closeMenu()
              }
              className={
                active === "contact"
                  ? "mobileMenu__contentItem activeNavbarmobile"
                  : "mobileMenu__contentItem"
              }
            >
              <span className="mobileMenu__contentItemText">Contact</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar2;
